import React from 'react';
import { Link } from 'react-router-dom';
import { publicFooterLinks } from './PublicLayout';

const features = [
    ['Live share registry', 'Search holders, top-20 movements and daily reports'],
    ['Investor email marketing', 'Templates, contacts and campaigns with open & click tracking'],
];

const BrandPanel = () =>
    <div className="brand-panel">
        <img className="brand-bg" src="/images/login/brand-panel.jpg" alt="" />
        <div className="deco-ring big" />
        <div className="deco-ring small" />
        <img className="brand-logo" src="/images/login/logo-brand.svg" alt="Investi" />
        <div className="brand-copy">
            <h1>Investor relations,<br/>made effortless.</h1>
            <p className="sub">Registry insights, ASX announcements and investor email — one workspace for every listed client you manage.</p>
            <div className="features">
                {features.map(([title, desc]) =>
                    <div className="feature" key={title}>
                        <img src="/images/login/check.svg" alt="" />
                        <div className="t">
                            <p>{title}</p>
                            <p>{desc}</p>
                        </div>
                    </div>)}
            </div>
        </div>
        <div className="brand-footer">
            <span>© {new Date().getFullYear()} Investi</span>
            {publicFooterLinks.map(x => <Link key={x.to} to={x.to}>{x.label}</Link>)}
        </div>
    </div>;

export default BrandPanel;
